class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.targets = document.querySelectorAll("[data-header-target]");
    this.sticking = false;
    this.hasPassedStickTarget = false;

    const setHeightVariable = () =>
      document.documentElement.style.setProperty(
        "--header-height",
        `${this.getBoundingClientRect().height}px`,
      );
    window.requestAnimationFrame(setHeightVariable);
    window.addEventListener("resize", setHeightVariable);

    this._moveStickTarget();
    this._initScrollDirectionHandler();
    this._initActiveHoverHandlers();
    this._initCustomSelectTrigger();
  }

  _moveStickTarget() {
    if (Shopify?.designMode) return;

    const target = document.querySelector('[data-header-target="stick"]');
    const header = this.closest(".shopify-section--header");

    if (!target || !header) return;

    header.parentNode.insertBefore(target, header);
    requestAnimationFrame(() => {
      this.stickTargetOffset = window.innerHeight - 50;
    });
  }

  _initScrollDirectionHandler() {
    let lastScrollY = window.scrollY;
    let ticking = false;

    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;

        requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          const triggerPoint = this.stickTargetOffset || window.innerHeight;

          const isPastTarget = currentScrollY > triggerPoint;
          const isScrollingUp = currentScrollY < lastScrollY;
          const isScrollingDown = currentScrollY > lastScrollY;
          const isMobileMenuOpen = this.querySelector(".header__mobile-menu.open");

          if (isMobileMenuOpen) {
            this.classList.add("is-fixed", "is-visible");
            this.classList.remove("is-hidden");
            lastScrollY = Math.max(currentScrollY, 0);
            ticking = false;
            return;
          }

          this.hasPassedStickTarget = isPastTarget;

          if (!isPastTarget) {
            this.classList.remove("sticking", "is-fixed", "is-hidden");
            this.classList.add("is-visible");
            document.body.classList.remove("header--sticking");
          } else {
            this.classList.add("sticking", "is-fixed");
            document.body.classList.add("header--sticking");

            if (isScrollingUp) {
              this.classList.add("is-visible");
              this.classList.remove("is-hidden");
            }

            if (isScrollingDown) {
              this.classList.add("is-hidden");
              this.classList.remove("is-visible");
            }
          }

          lastScrollY = Math.max(currentScrollY, 0);
          ticking = false;
        });

        ticking = true;
      },
      { passive: true }
    );
  }

  _getTopmostParentLi(li, container) {
    let currentLi = li;
    let parentLi = currentLi.closest("ul")?.closest("li");
    while (parentLi && container.contains(parentLi)) {
      currentLi = parentLi;
      parentLi = currentLi.closest("ul")?.closest("li");
    }
    return currentLi;
  }

  _initActiveHoverHandlers() {
    const nav = this.querySelector(".header__main-nav");

    this.addEventListener("mouseover", (e) => {
      const li = e.target.closest("li");
      if (li && this.contains(li)) {
        li.classList.add("has-active");

        // Ensure topmost parent li gets .has-active
        const topLi = this._getTopmostParentLi(li, nav);
        if (topLi) {
          topLi.classList.add("has-active");
        }

        nav.classList.add("has-hover-active");
      }
    });

    this.addEventListener("mouseout", (e) => {
      const li = e.target.closest("li");
      if (li && this.contains(li)) {
        li.classList.remove("has-active");

        // Remove .has-active from topmost parent li if no active descendants remain
        const topLi = this._getTopmostParentLi(li, nav);
        if (topLi) {
          const stillActive = topLi.querySelector("li.has-active");
          if (!stillActive) {
            topLi.classList.remove("has-active");
          }
        }
      }
      nav.classList.remove("has-hover-active");
    });

    this.addEventListener("click", (e) => {
      const li = e.target.closest("li");
      if (li && this.contains(li)) {
        li.parentElement.querySelectorAll("li.has-active").forEach((sibling) => {
          if (sibling !== li) sibling.classList.remove("has-active");
        });
        li.classList.add("has-active");

        // Ensure topmost parent li gets .has-active
        const topLi = this._getTopmostParentLi(li, nav);
        if (topLi) {
          topLi.classList.add("has-active");
        }

        nav.classList.add("has-hover-active");
      }
    });
  }

  _initCustomSelectTrigger() {
      const displayDiv = this.querySelector("#selected-country-display");
      const select = displayDiv?.nextElementSibling;

      if (!displayDiv || !select) return;

      displayDiv.addEventListener("click", function () {
        if (typeof select.showPicker === "function") {
          select.showPicker();
          return;
        }
        const event = new MouseEvent('mousedown', {
          view: window,
          bubbles: true,
          cancelable: true
        });
        select.dispatchEvent(event);
      });
  }

}

if (!customElements.get("sticky-header")) {
  customElements.define("sticky-header", StickyHeader);
}
